
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';
import Message from '@/components/message.vue';
import {
	liveRoomlist,
	liveRoomdataStatistics,
	liveRoomsync,
	liveRoomdelete,
	liveRoomEdit
} from "@/api/live"
import {
	getSearchDate,
	nextDay,
	lastmonth
} from "@/utils"
import { number } from 'echarts';

import {
	livemallLiveConfig,
} from "@/api/auth"
@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate,
		'slz-dialog': Dialog,
		'slz-message': Message,
	}
})

export default class ProductList extends Vue {
	private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
	private keywords = ''
	private state = null
	private statelist = [
		{ value: null, label: '全部' },
		{ value: 101, label: '直播中' },
		{ value: 102, label: '未开始' },
		{ value: 103, label: '已结束' },
		{ value: 104, label: '禁播' },
		{ value: 105, label: '暂停' },
		{ value: 106, label: '异常' },
		{ value: 107, label: '已过期' },
	]
	private filterTime = [lastmonth(1, 1), lastmonth(-1, 1)].join('/')
	private pageSize = 10
	private pageNo = 1
	private total = 0
	private tablelist: any = []
	private tableloading = false

	private newliveShow = false
	private pullnum = 10
	private pullloading = false

	private rowmsg: any = {}
	private dataShow = false
	private datamsg: any = {}
	private dataloading = false

	private IsShowHomePage = false
	private detailShow = false

	created() {
		// console.log(this.filterTime)
		this.gettablelist()
	}
	activated() {
		this.gettablelist()
	}


	private async confirmDel() {
		if (this.IsShowHomePage) return
		try {
			let res = await liveRoomdelete({
				Id: this.rowmsg.Id
			})
			if (res.IsSuccess) {
				this.$message.success('删除成功')
				this.gettablelist()
			}
		} finally {
			//
		}
	}
	private async detailroom(row) {
		this.tableloading = true
		this.IsShowHomePage = false
		try {
			let res = await livemallLiveConfig({})
			if (res.IsSuccess) {
				this.rowmsg = row
				console.log(row)
				this.IsShowHomePage = row.Id == res.Result.LiveRoomId
				this.detailShow = true
			}
		} finally {
			this.tableloading = false
		}
	}

	private toshop(row) {
		this.$router.push({
			path: 'shopmanagement',
			query: {
				Id: row.Id,
				type: row.LiveStatus
			}
		})
	}
	private toactivity(row) {
		this.$router.push({
			path: 'helpactivity',
			query: {
				Id: row.ActivityHelpId,//
				liveId: row.Id,//自己的直播间Id
			}
		})
	}
	private getliveData(row) {
		this.rowmsg = row
		this.dataShow = true
		this.getdata()
	}
	private async getdata() {
		this.dataloading = true
		try {
			let res = await liveRoomdataStatistics({
				LiveRoomId: this.rowmsg.Id
			})
			if (res.IsSuccess) {
				this.datamsg = res.Result
			}
		} finally {
			this.dataloading = false
		}
	}
	private async gettablelist() {
		try {
			this.tableloading = true
			let data: any = {
				Keywords: this.keywords,
				LiveStatus: this.state,
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
			}
			if (this.filterTime) {
				var splitList = this.filterTime.split('/');
				data.SearchStartTime = splitList[0];
				data.SearchEndTime = splitList[1] ? (nextDay(splitList[1], 1)) : '';
			}
			let res: any = await liveRoomlist(data)
			if (res.IsSuccess) {
				this.tablelist = res.Result.Results.map(item=>{
					item.showIcon = false;
					item.SortDescCopy = item.SortDesc;
					item.visible = false;
					return item
				})
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading = false
		}
	}
	private async confirmpull() {
		// let num = String(this.pullnum)
		// console.log(this.pullnum,parseInt(num),this.pullnum!=Number(num))
		if (!this.pullnum || this.pullnum == 0) {
			(this.pullnum as any) = ''
			this.$message.error('请输入要拉取的房间数量')
			return
		} else if (this.pullnum > 100) {
			this.$message.error('每次拉取数量请不要超过100')
			return
		}
		try {
			this.pullloading = true
			let res: any = await liveRoomsync({
				TopCount: this.pullnum
			})
			this.$message.success('已提交，更新中')
			if (res.IsSuccess) {
				this.newliveShow = false
				this.gettablelist()
			}
		} finally {
			this.pullloading = false
		}
	}
	private changeCurrent(e) {
		this.pageNo = e
		this.gettablelist()
	}
	private doSearch() {
		this.pageNo = 1
		this.gettablelist()
	}
	private getnewlive() {
		this.newliveShow = true
		this.pullnum = 10
	}
	private async handleSaveSort(record){
		
        let sort = record.SortDescCopy + '';
        let sortNum = +sort;
        if (isNaN(sortNum) || sortNum < 0 || sortNum > 999999){
            this.$message.error('请输入0~999999的整数');
            return;
        }

        if (sort.indexOf('.') > -1){
            this.$message.error('请输入0~999999的整数');
            return;
        }

        if (this.tableloading) return;
        this.tableloading = true;
        try {
            await liveRoomEdit({ Id: record.Id, SortDesc: record.SortDescCopy });
            this.$message.success('操作成功');
            record.visible = false;
            this.gettablelist();
        } catch (error) {

        } finally{
             this.tableloading = false;
        }
    }
}
